/**
 * 知识产权查询相关API接口
 */
import request from './utils/request'

/**
 * 统一查询接口
 * @param {string} certificateType - 证书类型：0 数字备案、1 作品登记、2 软著、3 商标、4 专利
 * @param {string} keyword - 查询关键词
 * @param {number} pageNum - 页码
 * @param {number} pageSize - 每页数量
 * @returns {Promise} 查询结果
 */
export function queryIntellectualProperty(certificateType, keyword, pageNum = 1, pageSize = 10) {
  return request({
    url: '/web/intellectualPropertyQuery/query',
    method: 'get',
    params: {
      certificateType: certificateType,
      keyword: keyword,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

/**
 * 统一导出接口
 * @param {string} certificateType - 证书类型：0～4
 * @param {string} keyword - 查询关键词
 * @param {number} pageNum - 页码
 * @param {number} pageSize - 每页数量
 * @returns {Promise} 导出结果
 */
export function exportIntellectualProperty(certificateType, keyword, pageNum = 1, pageSize = 10) {
  return request({
    url: '/web/intellectualPropertyQuery/export',
    method: 'post',
    params: {
      certificateType: certificateType,
      keyword: keyword,
      pageNum: pageNum,
      pageSize: pageSize
    },
    responseType: 'blob'
  })
}

/**
 * 导入知产管理
 * @param {string} certificateType - 证书类型：0～4
 * @param {string} keyword - 查询关键词（与列表查询一致）
 * @returns {Promise}
 */
export function importIntellectualPropertyToManagement(certificateType, keyword) {
  return request({
    url: '/web/intellectualPropertyQuery/importAsset',
    method: 'post',
    params: {
      certificateType,
      keyword: keyword != null ? String(keyword) : ''
    }
  })
}
